(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["business-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('business-intro-slides')) {
    class BusinessIntroSlides extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.step(-1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.step(1));
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target instanceof Element ? event.target.closest('.business-intro__slide') : null;
          if (slide) this.track.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });
        });
      }

      /** Moves one photo; wraps around at the ends. */
      step(direction) {
        const width = this.track.clientWidth;
        const count = this.track.children.length;
        const current = Math.round(this.track.scrollLeft / width);
        const next = (current + direction + count) % count;
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: next * width, behavior: smooth ? 'smooth' : 'auto' });
      }
    }
    customElements.define('business-intro-slides', BusinessIntroSlides);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
